<app-battlecards-demo #battlecardsDemo></app-battlecards-demo>

<app-main-wrapper title="Upload">
  <button
    page-actions
    type="button"
    class="page-help"
    (click)="openBattlecardsDemo()"
    aria-label="Explain Battlecards"
    title="Explain Battlecards"
  >
    ?
  </button>

<div class="upload-container">
  <div class="web-sources-card">
    <div class="ws-title-row">
      <div class="ws-title">Add priority URLs</div>
      <button
        *ngIf="isFreeEmailDomain"
        type="button"
        class="step-help"
        (click)="toggleFreeEmailTooltip()"
        aria-label="Why free emails need URLs"
        title="Why free emails need URLs"
      >
        ?
      </button>
      <div class="free-email-tooltip" *ngIf="showFreeEmailTooltip && isFreeEmailDomain">
        <span class="free-email-tooltip-text">Free email domains (like {{ userDefaultDomain }}) aren't prioritized. Add a custom URL to continue.</span>
        <button type="button" class="tooltip-close" (click)="closeFreeEmailTooltip()" aria-label="Close free email tooltip">✕</button>
      </div>
    </div>
    <div class="ws-desc">Help convverse prioritize from your websites and docs for Battlecards.</div>

    <div class="ws-list">
      <div *ngFor="let source of webSources; let i = index" class="ws-row">
        <div class="ws-check">✓</div>
        <div class="ws-info">
          <div class="ws-domain">{{ source }}</div>
          <div class="ws-sub" *ngIf="source === userDefaultDomain">Detected from your work email domain</div>
        </div>
        <span class="ws-badge">Selected</span>
        <button
          type="button"
          class="icon-remove"
          (click)="removeWebSource(i)"
          [disabled]="isSavingSources"
          aria-label="Remove URL"
        >
          ✕
        </button>
      </div>
    </div>

    <div class="ws-add-row">
      <input
        class="ws-add-input"
        placeholder="Add another URL, e.g. docs.company.com"
        [(ngModel)]="newWebSource"
        (keydown.enter)="addWebSource()"
      />
      <button class="btn-secondary" (click)="addWebSource()" [disabled]="isSavingSources" [class.loading]="isSavingSources">
        <span *ngIf="!isSavingSources">Add URL</span>
        <span *ngIf="isSavingSources" class="loading-dots">
          <span></span><span></span><span></span>
        </span>
      </button>
    </div>
  </div>

  <div
    class="upload-box"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <p class="upload-text">Drag and drop your PDFs here</p>
    <label for="file-upload" class="btn btn-black">Select files</label>
    <input
      id="file-upload"
      type="file"
      class="hidden"
      accept="application/pdf,.pdf"
      multiple
      (change)="onFileSelect($event)"
    />
  </div>

  <div class="files-container">
    <h2 class="files-title">Uploaded Files</h2>
    <ul class="files-list">
      <ng-container *ngIf="pendingUploads.length">
        <li *ngFor="let pending of pendingUploads" class="file-item pending-row" [class.error-row]="pending.status === 'error'">
          <div class="file-info">
            <div class="file-header">
              <span class="file-name muted">
                <span class="file-name-text">{{ pending.name }}</span>
              </span>
              <span class="file-status" [ngClass]="pending.status === 'error' ? 'status-failed' : 'status-processing'">
                {{ pending.status === 'error' ? 'error' : 'uploading' }}
              </span>
            </div>
            <div class="pending-messages">
              <span class="file-note primary-message">
                {{ pending.uploadError ? pending.uploadError : pending.note }}
              </span>
              <span class="file-note secondary-message" *ngIf="pending.uploadError">
                {{ pending.note }}
              </span>
            </div>
          </div>
          <div class="pending-actions" *ngIf="pending.status === 'error'; else uploadingControls">
            <button type="button" class="btn btn-black" (click)="retryPendingUpload(pending)">Retry</button>
            <button type="button" class="btn" (click)="dismissPendingError(pending)">Dismiss</button>
          </div>
          <ng-template #uploadingControls>
            <div class="pending-progress">
              <span class="progress-indicator"></span>
            </div>
          </ng-template>
        </li>
      </ng-container>
      <li *ngIf="!pendingUploads.length && !uploadedFiles.length" class="file-item empty-row">
        <div class="file-info">
          <div class="file-header">
            <span class="file-name muted">No files uploaded yet.</span>
          </div>
          <span class="file-note">Drop a file above or select one to get started.</span>
        </div>
      </li>
      <li *ngFor="let file of uploadedFiles" class="file-item">
        <div class="file-info">
          <div class="file-header">
            <span class="file-name" (click)="downloadFile(file)" [attr.title]="file.name">
              <span class="file-name-text">{{ file.name }}</span>
            </span>
            <span class="file-status" 
                  [ngClass]="getStatusClass(file.status || 'pending')"
                  [title]="file.error_message || ''">
              {{ file.status || 'pending' }}
            </span>
          </div>
          <span class="file-note">{{ file.note }}</span>
        </div>
        <button class="btn delete-button" (click)="confirmDelete(file)">
          Delete
        </button>
      </li>
    </ul>
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<div class="dialog-overlay" *ngIf="showDeleteConfirmation">
  <div class="delete-dialog">
    <div class="dialog-header">
      <h2>Confirm Delete</h2>
      <p class="dialog-subtitle">Are you sure you want to delete this file?</p>
      <p class="file-to-delete">{{ fileToDelete?.name }}</p>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn" (click)="cancelDelete()">Cancel</button>
      <button type="button" class="btn btn-black" (click)="deleteFile()">Delete</button>
    </div>
  </div>
</div>
</app-main-wrapper>
